module.exports = __webpack_public_path__ + "img/hiking007.7f4fecf3.jpg";